import React, { Component } from "react";
import { Grid } from "@mui/material";
import { connect } from "react-redux";
import {
  loadLocationsBegin,
  clearLocations,
} from "../actions/locationsactions";
import { editBandLocation } from "../actions/editbandactions";

class CustomLocationInput extends Component {
  state = {
    search: "",
  };

  constructor(props) {
    super(props);
    this.loadLocations = this.loadLocations.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.formatLocation = this.formatLocation.bind(this);
  }

  formatLocation(location) {
    return `${location.locality === null ? "" : location.locality + ","} ${
      location.stateCounty
    }, ${location.country}`;
  }

  loadLocations(e) {
    const { dispatch } = this.props;
    dispatch(loadLocationsBegin(e.target.value));

    this.setState({
      search: e.target.value,
    });
  }

  selectLocation(location) {
    const { dispatch } = this.props;

    dispatch(editBandLocation(this.formatLocation(location)));
    dispatch(clearLocations());

    this.setState({
      search: "",
    });
  }

  render() {
    const { location, locations } = this.props;

    return (
      <React.Fragment>
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          spacing={2}
        >
          <Grid item xs={12}>
            <label>{location ? location : "None Selected"}</label>
          </Grid>
          <Grid item xs={12}>
            <input
              className="textbox"
              placeholder="Type Location and Select"
              value={this.state.search}
              onChange={this.loadLocations}
            />
          </Grid>
        </Grid>

        {locations.map((location) => {
          return (
            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              spacing={2}
            >
              <Grid item xs={12}>
                <div
                  className="suggestiondiv"
                  onClick={() => this.selectLocation(location)}
                  key={`${location} div`}
                >
                  <label key={`${location} label`} className="suggestion">
                    {this.formatLocation(location)}
                  </label>
                </div>
              </Grid>
            </Grid>
          );
        })}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  location: state.editband.location,
  locations: state.locations.locations,
});

export default connect(mapStateToProps)(CustomLocationInput);
